/**
 * Created by ori on 08/08/16.
 */
'use strict';
import axios from 'axios';
import Promise from 'bluebird';

export default function (api,endPoint,data) {

    let url = `/${api}/` + endPoint
    if (window.location.hostname.indexOf('.local') > -1 || window.location.origin == 'http://localhost:3000') {
      url = 'http://tipigo.local' + url
    }

    return axios
        .post(url, data)
        .catch(err => {
            return Promise.reject(err.response ? err.response.data : err);
        })
        .then(response => response.data);
};



// WEBPACK FOOTER //
// ./src/js/lib/api-request.js